import { colors } from '@material-ui/core';
const { contrastTextColor, darkColor, mainColor, lightColor, backgoundColor, backgoundColorPaper, textColor } = window['runConfig'];

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: contrastTextColor,
    dark: darkColor,
    main: mainColor,
    light: lightColor
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: textColor,
    secondary: textColor,
    link: colors.blue[600]
  },
  background: {
    default: backgoundColor,
    paper: backgoundColorPaper
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200]
};
